<ng-container panel-content>
	@if (allImages()?.length) {
		<div class="image-container">
			<div class="image-scroll-wrapper nice-scroll visible-scroll colored-scroll-track">
				@for (image of allImages(); track $index; let i = $index) {
					<div class="image-item" (click)="openImage(i)">
						@if (newEntity()) {
							<button
								mat-icon-button
								class="remove-icon tonal-icon-button"
								(click)="removeFile.emit(image.file)"
							>
								<mat-icon svgIcon="close" />
							</button>
						}
						@if (image.file?.url) {
							<img
								ngSrc="{{ image.file.url }}"
								alt="image"
								width="300"
								height="200"
								priority
							/>
						} @else if (image?.url) {
							<img
								[src]="image.url"
								[alt]="('loading_dialog_status' | translate) + '...'"
								width="300"
								height="200"
								priority
							/>
						}
					</div>
				}
				@if (!newEntity()) {
					<div class="image-item add-image-placeholder" (click)="fileInput.click()">
						<mat-icon svgIcon="add_a_photo"></mat-icon>
					</div>
				}
			</div>
		</div>
	} @else if (!newEntity()) {
		<div class="no-images-placeholder" (click)="fileInput.click()">
			<mat-icon svgIcon="add_a_photo" />
			<p>{{ 'upload_images' | translate }}</p>
		</div>
	}
</ng-container>

<input
	#fileInput
	type="file"
	[accept]="fileTypesConfig"
	[multiple]="true"
	(click)="$event.target['value'] = null"
	(change)="fileChanged($event)"
	hidden
/>
